/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Assistant Avatar
 */
export const createAssistantAvatar = (
    assistantId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      assistantId = toValue(assistantId);

      return axiosClient<void>(
      {url: `/ai/assistants/${assistantId}/assistant_avatars`, method: 'POST', signal
    },
      );
    }




export const getCreateAssistantAvatarMutationKey = () => ['createAssistantAvatar'] as const;

export const getCreateAssistantAvatarMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantAvatar>>, TError,CreateAssistantAvatarMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAssistantAvatar>>, TError,CreateAssistantAvatarMutationVariables, TContext> => {

const mutationKey = getCreateAssistantAvatarMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssistantAvatar>>, CreateAssistantAvatarMutationVariables> = (props) => {
          const {assistantId} = props ?? {};

          return  createAssistantAvatar(assistantId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssistantAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof createAssistantAvatar>>>

    export type CreateAssistantAvatarMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateAssistantAvatarMutationVariables = {assistantId: string}

    /**
 * @summary Create AI Assistant Avatar
 */
export const useCreateAssistantAvatar = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantAvatar>>, TError,CreateAssistantAvatarMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAssistantAvatar>>,
        TError,
        CreateAssistantAvatarMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAssistantAvatarMutationOptions(options), queryClient);
    }
